import * as React from 'react';
import { DocumentTitleOptions, LinkingOptions, NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { useAPI } from '../Universal/API/API';
import HomeScreen from '../HomeScreen/HomeScreen';
import { useAppContext } from '../Universal/API/Context-API/AppContext';
import UnitFullV2 from '../UnitFull/UnitFullV2';
import ScreenWrapper from './TopNavigator/ScreenWrapper/ScreenWrapper';







import About from '../About/About';
import Collection from '../Collection/Collection';
import Collections from '../Collections/Collections';
import WhereToBuy from '../WhereToBuy/WhereToBuy';
import SearchPage from '../SearchPage/SearchPage';
import Contacts from '../Contacts/Contacts';
import TopNavigator from './TopNavigator/TopNavigator';
import { Box } from 'native-base';
import { ScrollView } from 'react-native-gesture-handler';
import Portfolio from '../Portfolio/Portfolio';
import Catalog from '../Catalog/Catalog';
import CartPage from '../Cart/Cart';
// Service
import Account from './Components/Service/Account/Account';


import { useOptions } from './Components/hooks/useOptiions';
import Catalogs from './Components/Service/Catalogs/Catalogs';
import LicensesAndCertificates from './Components/Service/LicensesAndCertifiactes/LicensesAndCertificates'
import InstructionsBuild from './Components/Service/InstructionsBuild/InstructionsBuild';
import ServiceCenter from './Components/Service/ServiceCenter/ServiceCenter';

// export default React.memo(Navigator);

import {linking} from './linking'
import { getDataFromStorage, setDataToStorage } from '../Universal/API/Context-API/Storage/Storage';
import { handleExpandedMenu } from './TopNavigator/ExpandedMenu/utils';
import { navigationRef, setCurrentRouteSnapshot } from './navigationRef';

const Stack = createStackNavigator();


const NAVIGATION_STATE_KEY = '1445'
const StackNavigator = () => {
  const navigation = navigationRef
  
  // const refExpandedMenu = React.useRef<handleExpandedMenu>(null)
  const {
    optionsFunction,
    refSlideOutMenu,
    menuBarHover,
    serviceMobile, setServiceMobile
  } = useOptions({navigation, refExpandedMenu: null})

  const options = optionsFunction({
    variant: 'top',
   
  })

  const scrollViewRef = React.useRef<ScrollView>(null);

  const screeWrapperProps = {
    options: options,
    refSlideOutMenu: refSlideOutMenu, 
    scrollViewRef: scrollViewRef
  }

   const [initialState, setInitialState] = React.useState()
  const [isReady, setIsReady] = React.useState(false)

  React.useEffect(() => {
    const restoreState = async () => {
      try {
        const savedState = getDataFromStorage(NAVIGATION_STATE_KEY)

        if (savedState) {
          setInitialState(savedState)
        }
      } finally {
        setIsReady(true)
      }
    }

    restoreState()
  }, [])

  if (!isReady) return null

  return (
    <Box flex={1}>
      <>
        {options && <TopNavigator navigation={navigation} options={serviceMobile ?? options} refSlideOutMenu={refSlideOutMenu} menuBarHover={menuBarHover} setServiceMobile={setServiceMobile} />}
        {/* {options && <SlideOutMenu options = {options} ref={refSlideOutMenu}/>} */}
        {/* <TopNavigator ref={refTopNavigator} navigation = {navigation} refTopSlideOut = {refTopSlideOut} refSlideOutMenu={refSlideOutMenu} options={options_top}/>       */}

      </>
      <NavigationContainer linking={linking} ref={navigation}
      onReady={() => {
        setCurrentRouteSnapshot(navigation.getCurrentRoute() ?? null)
      }}
      onStateChange={(state) =>
        {
          setDataToStorage(NAVIGATION_STATE_KEY, JSON.stringify(state))
          setCurrentRouteSnapshot(navigation.getCurrentRoute() ?? null)
        }
      }
      documentTitle={{
        enabled: false
      }}>
        <Stack.Navigator
          screenOptions={{
            header: (props) => null
          }}
        >
          <Stack.Screen
            name="Home"
            options={{

              headerShown: true,
              // title: 'Добро пожаловать | Бренд Deante',
              // headerMode: ''

              animationEnabled: false
            }}
          >
            {(props) => (
              <ScreenWrapper {...props} {...screeWrapperProps} noScroll={true}>
                <HomeScreen {...props} />
              </ScreenWrapper>
            )}
          </Stack.Screen>
          <Stack.Screen
            name="Portfolio"
            options={{
              headerShown: true,
              // title: 'Портфолио Deante',  
              animationEnabled: false
            }}
          >
            {(props) => (
              <ScreenWrapper {...props} {...screeWrapperProps}>
                <Portfolio {...props} />
              </ScreenWrapper>
            )}
          </Stack.Screen>
          <Stack.Screen
            name="Unit"
            options={{
              headerShown: true,
              detachPreviousScreen: true,
              
              // title: 'Кемамогранит фабрики Deante',  
              animationEnabled: false
            }}
          >
            {(props) => (
              <ScreenWrapper {...props} {...screeWrapperProps}>
                <UnitFullV2 {...props} />
              </ScreenWrapper>
            )}
          </Stack.Screen>

          <Stack.Screen
            name="SearchPage"
            options={{
              headerShown: true,
              // title: 'Поиск по фабрике Deante',  
              animationEnabled: false
            }}
          >
            {(props) => (
              <ScreenWrapper {...props} {...screeWrapperProps} noScroll={true}>
                <SearchPage {...props} />
              </ScreenWrapper>
            )}
          </Stack.Screen>

          <Stack.Screen
            name="About"

            options={{
              headerShown: true,
              // title: 'О бренде Deante',  
              animationEnabled: false
            }}
          >
            {(props) => (
              <ScreenWrapper {...props} {...screeWrapperProps} noScroll={false}>
                <About {...props} />
              </ScreenWrapper>
            )}
          </Stack.Screen>

          <Stack.Screen
            name="Collection"
            options={{
              headerShown: true,
              // title: 'Коллекция фабрики Deante',  
              animationEnabled: false
            }}
          >
            {(props) => (
              <ScreenWrapper {...props} {...screeWrapperProps}  noScroll={true}>
                <Collection {...props} />
              </ScreenWrapper>
            )}
          </Stack.Screen>
          <Stack.Screen
            name="Collections"
            options={{
              headerShown: true,
              // title: 'Коллекции фабрики Deante',  
              animationEnabled: false
            }}
          >
            {(props) => (
              <ScreenWrapper {...props} {...screeWrapperProps}>
                <Collections {...props} scrollViewRef={scrollViewRef} />
              </ScreenWrapper>
            )}
          </Stack.Screen>

          <Stack.Screen
            name="Catalog"
            options={{
              headerShown: true,
              animationEnabled: false
            }}
          >
            {(props) => (
              <ScreenWrapper {...props} {...screeWrapperProps} noScroll={true}>
                <Catalog {...props} scrollViewRef={scrollViewRef} />
              </ScreenWrapper>
            )}
          </Stack.Screen>

          <Stack.Screen
            name="Cart"
            options={{
              headerShown: true,
              animationEnabled: false
            }}
          >
            {(props) => (
              <ScreenWrapper {...props} {...screeWrapperProps} noScroll={true}>
                <CartPage {...props} />
              </ScreenWrapper>
            )}
          </Stack.Screen>

{/* Service */}

          <Stack.Screen
            name="Account"
            options={{
              headerShown: true,
              animationEnabled: false
            }}
          >
            {(props) => (
              <ScreenWrapper {...props} {...screeWrapperProps}>
                <Account {...props} scrollViewRef={scrollViewRef} />
              </ScreenWrapper>
            )}
          </Stack.Screen>

<Stack.Screen
            name="Catalogs"
            options={{
              headerShown: true,
              animationEnabled: false
            }}
          >
            {(props) => (
              <ScreenWrapper {...props} {...screeWrapperProps} noScroll={true}>
                <Catalogs {...props} scrollViewRef={scrollViewRef}  />
              </ScreenWrapper>
            )}
          </Stack.Screen>

          <Stack.Screen
            name="InstructionsBuild"
            options={{
              headerShown: true,
              animationEnabled: false
            }}
          >
            {(props) => (
              <ScreenWrapper {...props} {...screeWrapperProps} noScroll={true}>
                <InstructionsBuild {...props} scrollViewRef={scrollViewRef}  />
              </ScreenWrapper>
            )}
          </Stack.Screen>

          <Stack.Screen
            name="ServiceCenter"
            options={{
              headerShown: true,
              animationEnabled: false
            }}
          >
            {(props) => (
              <ScreenWrapper {...props} {...screeWrapperProps}>
                <ServiceCenter {...props} />
              </ScreenWrapper>
            )}
          </Stack.Screen>

<Stack.Screen
            name="LicensesAndCertificates"
            options={{
              headerShown: true,
              animationEnabled: false
            }}
          >
            {(props) => (
              <ScreenWrapper {...props} {...screeWrapperProps}>
                <LicensesAndCertificates {...props} scrollViewRef={scrollViewRef} />
              </ScreenWrapper>
            )}
          </Stack.Screen>
          {/*  */}


          <Stack.Screen
            name='WhereToBuy'
            options={{
              headerShown: true,
              // title: 'Где купить Deante?',  
              animationEnabled: false,
            }}
          >
            {(props) => (
              <ScreenWrapper {...props} {...screeWrapperProps} noScroll={true}>
                <WhereToBuy {...props} />
              </ScreenWrapper>
            )}

          </Stack.Screen>

          <Stack.Screen
            name='Contacts'

            options={{
              headerShown: true,
              // title: 'Контакты Deante',  
              // meta
              animationEnabled: false,
            }}
          >
            {(props) => (
              <ScreenWrapper {...props} {...screeWrapperProps}>
                <Contacts {...props} />
              </ScreenWrapper>
            )}

          </Stack.Screen>
        </Stack.Navigator>
      </NavigationContainer>
    </Box>
  )
};




export interface defaultNavigationProps {
  navigation: any;
  route?: any
}


// Main Navigator
const Navigator: React.FC<any> = () => {
  const { X_API_TOKEN } = useAppContext();
  const { refreshData, serverUrl } = useAPI();

  const refRefreshData = React.useRef<null | number>(null)

  

  React.useEffect(() => {
    if (refRefreshData.current) {
      clearInterval(refRefreshData.current);
    }

    refreshData();

    refRefreshData.current = window.setInterval(() => {
      refreshData();
    }, 5 * 60 * 1000); // every 5 minutes

    return () => {
      if (refRefreshData.current) {
        clearInterval(refRefreshData.current);
      }
    };
  }, [X_API_TOKEN, serverUrl]);

  return (
    <StackNavigator />
  );
};



export default React.memo(Navigator);
